function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = function (app, mod) {
  var _app$options$stun, _app$options$stun2, _mod$streams;
  var privacy = ((_app$options$stun = app.options.stun) === null || _app$options$stun === void 0 || (_app$options$stun = _app$options$stun.settings) === null || _app$options$stun === void 0 ? void 0 : _app$options$stun.privacy) || 'all';
  return "\n    <div class=\"stun-settings-shell\">\n      <fieldset class=\"videocall-settings-group stun-settings-privacy\">\n        <legend class=\"videocall-settings-heading\">Allow direct calls from</legend>\n        ".concat([['all', 'Anyone'], ['key', 'Acquaintances'], ['dh', 'Friends'], ['none', 'No one']].map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];
    return "\n            <label class=\"videocall-settings-option\">\n              <input class=\"saito-radio\" type=\"radio\" name=\"stun-privacy\"\n                value=\"".concat(value, "\" ").concat(privacy === value ? 'checked' : '', ">\n              <span>").concat(label, "</span>\n            </label>");
  }).join(''), "\n      </fieldset>\n      <fieldset class=\"videocall-settings-group\">\n        <legend class=\"videocall-settings-heading\">Call diagnostics</legend>\n        <label class=\"videocall-settings-option\">\n          <input class=\"saito-checkbox\" type=\"checkbox\" name=\"videocall-diagnostics\"\n            ").concat((_app$options$stun2 = app.options.stun) !== null && _app$options$stun2 !== void 0 && (_app$options$stun2 = _app$options$stun2.settings) !== null && _app$options$stun2 !== void 0 && _app$options$stun2.diagnostics ? 'checked' : '', ">\n          <span>Show connection status and log in each call window</span>\n        </label>\n        <p class=\"videocall-settings-help\">Includes signaling, connection attempts, media traffic and playback status.</p>\n      </fieldset>\n      ").concat(mod !== null && mod !== void 0 && (_mod$streams = mod.streams) !== null && _mod$streams !== void 0 && _mod$streams.active ? "\n        <fieldset class=\"videocall-settings-group stun-input-settings\" hidden>\n          <legend class=\"videocall-settings-heading\">Adjust inputs</legend>\n          <label class=\"videocall-device-option\" hidden>Camera\n            <select class=\"saito-form-select\" id=\"video-input\" aria-label=\"Camera\"></select>\n          </label>\n          <label class=\"videocall-device-option\" hidden>Microphone\n            <select class=\"saito-form-select\" id=\"audio-input\" aria-label=\"Microphone\"></select>\n          </label>\n        </fieldset>" : '', "\n    </div>");
};